export class ZonaTemporal {
    constructor(
        public anterior: string,
        public nuevo: string,
    ){}
}